/**
 * Safely extracts the localized string based on the current language or defaults.
 * @param {string|object} val - The value to localize.
 * @param {string} language - The current language code (e.g., 'en', 'vi').
 * @returns {string} - The localized string.
 */
export const getLocalizedText = (val, language) => {
  const normalizeLang = (lng) => {
    if (!lng) return "en";
    const l = String(lng).toLowerCase();
    if (l === "vietnam" || l === "vn" || l === "vi") return "vi";
    if (l === "english" || l === "en") return "en";
    return l;
  };
  const lang = normalizeLang(language);
  if (val && typeof val === "object" && !Array.isArray(val)) {
    return val[lang] ?? (lang === "vi" ? (val.vi ?? val.en ?? "") : (val.en ?? val.vi ?? ""));
  }
  return val ?? "";
};

/**
 * Alias for getLocalizedText for generic values.
 */
export const getLocalizedValue = (val, language) => getLocalizedText(val, language);

